<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_long" @click.stop="noTouch">
    <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="dialog_wrap_content">
        <div class="wrap_content_title">查看奖励</div>
        <div class="wrap_content_desc">
          <div class="form-checkbox"></div>
          <!-- <div class="form-checkbox">
            <div :class="(mobileOs === 'iOS')?'system_online':''" @click="tickSystem('iOS')">
              <img :src="staticUrl+'office/xzdzm/reservation/yuan.png'" class="yuan">
              IOS
            </div>
            <div :class="(mobileOs === 'android')?'system_online':''" @click="tickSystem('android')">
              <img :src="staticUrl+'office/xzdzm/reservation/yuan.png'" class="yuan">
              Android
            </div>
          </div> -->
          <div class="form-input">
            <img :src="staticUrl+'office/xzdzm/reservation/mobile.png'" alt class="icon-input">
            <input class="mobile-input" type="tel" @input="inputNumeric"  placeholder="1xxxxxxxxxx(共11位)" v-model.trim="mobileNum" />
          </div>
          <div class="form-input">
            <img :src="staticUrl+'office/xzdzm/reservation/code.png'" alt class="icon-input">
            <input class="code-input" type="tel" maxlength="6" placeholder="请输入验证码" v-model.trim="mobileCode" />
            <div class="code-btn" @click="sendCode">{{ sendSec>0?sendSec+'秒后再试':'获取验证码' }}</div>
          </div>
          <div class="login-checkbox">
            <input type="checkbox" value="" @change="checkboxChange">我同意个人资料的收集及接收奖励短信,<a href="/informationDetail?id=21" target="_blank">隐私协议</a>
          </div>
          <!-- <div class="login-checkbox">预约的同时即登入仙宗大掌门预约页面</div> -->
        </div>
        <div class="wrap_content_btns">
          <div class="btn-ok" @click="tickBook">确定</div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import utils from '@/utils/utils'

export default {
  name: 'ActLogin',
  props: {
    inviteUserId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isMobile',
      'staticUrl'
    ])
  },
  watch: {
    mobileNum (value) {
      if (value.length > 0) {
        this.mobileNum = value.replace(/[^0-9]/, '')
        if (value[0] !== '1') {
          this.mobileNum = ''
        }
        if (value.length > 11) {
          this.mobileNum = value.substr(0, 11)
        }
      }
    }
  },
  data () {
    return {
      mobileNum: '',
      mobileCode: '',
      mobileOs: utils.getSystemInfo(),
      sendSec: 0,
      isCheck: false,
      lockAppoint: false,
    }
  },
  created () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  methods: {
    ...mapActions(['ActReservation','ActCodeSend', 'ActAppoint', 'ActCodeList']),
    noTouch () {

    },
    inputNumeric (e) {
      this.mobileNum = e.target.value.replace(/\D/, '')
    },
    closeDialog () {
      this.$emit('onClose', true)
    },
    checkboxChange (e) {
      this.isCheck = e.target.checked
    },
    tickSystem (e) {
      this.mobileOs = e
    },
    sendCode () {
      this.mobileNum = this.mobileNum.trim()
      if (this.mobileNum.length !== 11) {
        this.showError('请输入正确的手机号码')
        return;
      }
      if (this.mobileNum.indexOf('0') === 0) {
        this.mobileNum = this.mobileNum.substr(1, this.mobileNum.length - 1)
      }
      if (this.sendSec > 0) {
        return;
      }
      this.sendSec = 60
      let timeId = setInterval(() => {
        this.sendSec--
        if (this.sendSec <= 0) {
          this.sendSec = 0
          clearInterval(timeId)
        }
      }, 1000)
      this.ActCodeSend({ mobile: this.mobileNum }).then(res => {
        this.showSuccess('验证码发送成功')
      }).catch(() => {
        this.showError('验证码发送失败')
      })
    },
    tickBook () {
      // if (this.mobileOs !=='iOS' && this.mobileOs !=='android') {
      //   this.showError('请选择您要预约的设备类型')
      //   return;
      // }
      if (this.mobileNum.length !== 11) {
        this.showError('请输入正确的手机号码')
        return;
      }
      this.mobileCode = this.mobileCode.trim()
      if (this.mobileCode.length !== 6) {
        this.showError('请输入6位的验证码')
        return;
      }
      if (!this.isCheck) {
        this.showError('请确认隐私协议选项内容')
        return;
      }

      if (this.lockAppoint) {
        return
      }
      let mobile = this.mobileNum;
      let utmSource = '';
      if (typeof (this.$route.query) !== 'undefined' && typeof (this.$route.query['utm_source']) !== 'undefined') {
        utmSource = this.$route.query['utm_source'];
      }
      this.lockAppoint = true
      this.ActAppoint({ mobile: mobile, code: this.mobileCode, utm_source: utmSource, os: this.mobileOs }).then((res) => {
        if (res.code === 1) {
          this.showError(res.msg)
        } else {
          this.lockAppoint = false
          this.ActReservation({ mobile: mobile })
          // if (res.is_first_appoint === 1) {
          //   this.$router.push({ name: 'reservationSuccess', query: this.$route.query })
          // } else {
          //   this.showSuccess('此手机号码已预约了！')
            this.$router.push({ name: 'reservationOk', query: this.$route.query })
          // }
        }
      }).catch((err) => {
        this.lockAppoint = false
        console.log(err)
        this.showSuccess('登录失败')
      })
    }
  }
}
</script>

<style lang="scss">

</style>
